/**
 * Modelo de referência de projeto utilizado no modelo de arquivos 3D.
 * @category Developments
 * @interface DevelopmentReference
 * @hideconstructor
 */
export class DevelopmentReference {
  /** ID do projeto. */
  id: string;
  /** Nome do projeto. */
  name: string;
  /** ID do usuário proprietário do projeto. */
  userId: string;

  constructor(id: string, name: string, userId: string) {
    this.id = id;
    this.name = name;
    this.userId = userId;
  }
}



// WEBPACK FOOTER //
// ./src/modules/development/models/DevelopmentReference.ts